export default {"src":"/_next/static/media/ic_fb.1145b7a4.svg","height":20,"width":20};